import { render, staticRenderFns } from "./KafkaConfigurationDetails.vue?vue&type=template&id=1383be35&"
import script from "./KafkaConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./KafkaConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1383be35')) {
      api.createRecord('1383be35', component.options)
    } else {
      api.reload('1383be35', component.options)
    }
    module.hot.accept("./KafkaConfigurationDetails.vue?vue&type=template&id=1383be35&", function () {
      api.rerender('1383be35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/KafkaConfigurationDetails.vue"
export default component.exports